import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RaceMetaDataEwTerms = withConfig(theme => styled('div', { label: 'RaceMetaDataEwTerms' })`
    background: ${theme.star.raceSectionHeader.bgColorSecondary};
    border-radius: 4px;
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-style: normal;
    gap: 4px;
    line-height: 1.3334;
    padding: 8px;
    width: 100%;
`);

export const RaceMetaDataEwTermsItem = styled('i', { label: 'RaceMetaDataEwTermsItem' })`
    font-style: normal;
`;
